<template>
  <hm-content title="">
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
      <el-form-item label="新客转化" prop="new_member">
        注册后
        <el-input
          clearable
          size="small"
          class="ml10 mr10"
          v-model="ruleForm.new_member"
          type="number"
          style="width:100px;"
          @mousewheel.prevent.native
          maxlength="50"
        ></el-input
        >天内未到店消费的客户
      </el-form-item>
      <el-form-item label="流失预警" prop="loss_warning">
        距离最后一次消费时间
        <el-input
          clearable
          size="small"
          class="ml10 mr10"
          v-model="ruleForm.loss_warning"
          type="number"
          style="width:100px;"
          @mousewheel.prevent.native
          maxlength="50"
        ></el-input
        >天未到店消费的客户
      </el-form-item>
      <el-form-item label="复购推荐" prop="repurchase_recommendation">
        距离客户购买某商品消耗完前
        <el-input
          clearable
          size="small"
          class="ml10 mr10"
          v-model="ruleForm.repurchase_recommendation"
          @mousewheel.prevent.native
          style="width:100px;"
          maxlength="50"
        ></el-input
        >天内未到店消费的客户
      </el-form-item>
      <el-form-item label="阶段营销" prop="today">
        在每个生理轴的临界点时间的客户
        <el-button type="primary" size="small" @click="gogogo"
          >去配置生理轴</el-button
        >
      </el-form-item>
    </el-form>
    <div class="dialog-footer flex flex-center">
      <el-button @click="submit('ruleForm')" size="small" type="primary"
        >确认</el-button
      >
    </div>
    <el-dialog
      title="生理轴配置"
      :close-on-click-modal="false"
      @close="dialogVisible = false"
      :visible.sync="dialogVisible"
      width="60%"
    >
      <el-form
        label-width="180px"
        :model="ruleFormShaft"
        :rules="rulesShaft"
        ref="ruleFormShaft"
      >
        <el-form-item label="孕妇生理周期分组设置" prop="pregnantendValue">
          <div class="flex flex-wrap">
            <div class="mr10">
              <div class="flex flex-wrap">
                <div style="width:50px">止步于</div>
                <el-input
                  clearable
                  size="small"
                  class="ml10 mr10"
                  v-model="ruleFormShaft.pregnantendValue"
                  @mousewheel.prevent.native
                  style="width:120px;"
                  maxlength="50"
                  placeholder="请输入数字"
                ></el-input>
              </div>
              <div class="flex flex-wrap">
                <div style="width:50px">步长</div>
                <el-input
                  clearable
                  size="small"
                  class="ml10 mr10"
                  v-model="ruleFormShaft.pregnantseparateValue"
                  @input="filterGt0OrFixed0('pregnantseparateValue')"
                  @mousewheel.prevent.native
                  style="width:120px;"
                  maxlength="50"
                  placeholder="请输入数字"
                ></el-input>
              </div>
            </div>
            <div class="ml10">
              <el-table
                stripe
                border
                ref="table"
                :data="zhouqi"
                style="width: 100%"
                size="small"
              >
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="mobilePhone"
                  width="240"
                  label="怀孕周期"
                >
                  <template slot-scope="scope">
                    <div class="blue">
                      {{ scope.row }}
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="宝宝月龄段分组设置" prop="babyendValue">
          <div class="flex flex-wrap">
            <div class="mr10">
              <div class="flex flex-wrap">
                <div style="width:50px">止步于</div>
                <el-input
                  clearable
                  size="small"
                  class="ml10 mr10"
                  v-model="ruleFormShaft.babyendValue"
                  @mousewheel.prevent.native
                  style="width:120px;"
                  maxlength="50"
                  placeholder="请输入数字"
                ></el-input>
              </div>
              <div class="flex flex-wrap">
                <div style="width:50px">步长</div>
                <el-input
                  clearable
                  size="small"
                  class="ml10 mr10"
                  v-model="ruleFormShaft.babyseparateValue"
                  @input="filterGt0OrFixed0('babyseparateValue')"
                  @mousewheel.prevent.native
                  style="width:120px;"
                  maxlength="50"
                  placeholder="请输入数字"
                ></el-input>
              </div>
            </div>
            <div class="ml10">
              <el-table
                stripe
                border
                ref="table"
                :data="babyzhouqi"
                style="width: 100%"
                size="small"
              >
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="mobilePhone"
                  width="240"
                  label="宝宝月龄段"
                >
                  <template slot-scope="scope">
                    <div class="blue">
                      {{ scope.row }}
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="会员年龄分组设置" prop="memberendValue">
          <div class="flex flex-wrap">
            <div class="mr10">
              <div class="flex flex-wrap">
                <div style="width:50px">止步于</div>
                <el-input
                  clearable
                  size="small"
                  class="ml10 mr10"
                  v-model="ruleFormShaft.memberendValue"
                  @mousewheel.prevent.native
                  style="width:120px;"
                  maxlength="50"
                  placeholder="请输入数字"
                ></el-input>
              </div>
              <div class="flex flex-wrap">
                <div style="width:50px">步长</div>
                <el-input
                  clearable
                  size="small"
                  class="ml10 mr10"
                  type="number"
                  v-model="ruleFormShaft.memberseparateValue"
                  @input="filterGt0OrFixed0('memberseparateValue')"
                  @mousewheel.prevent.native
                  style="width:120px;"
                  maxlength="50"
                  placeholder="请输入数字"
                ></el-input>
              </div>
            </div>
            <div class="ml10">
              <el-table
                stripe
                border
                ref="table"
                :data="memberzhouqi"
                style="width: 100%"
                size="small"
              >
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="mobilePhone"
                  width="240"
                  label="会员年龄段"
                >
                  <template slot-scope="scope">
                    <div class="blue">
                      {{ scope.row }}
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button
          @click="submitReject('ruleFormShaft')"
          size="small"
          type="primary"
          >确认</el-button
        >
        <el-button @click="dialogVisible = false" size="small" type="info"
          >取消</el-button
        >
      </span>
    </el-dialog>
  </hm-content>
</template>

<script>
export default {
  components: {},
  data() {
    const pregnantendValueFunc = function(rule, val, callback) {
      if (!this.ruleFormShaft.pregnantseparateValue) {
        return callback(new Error("请输入步长"));
      }
      callback();
    }.bind(this);
    const babyseparateValueFunc = function(rule, val, callback) {
      if (!this.ruleFormShaft.babyseparateValue) {
        return callback(new Error("请输入步长"));
      }
      callback();
    }.bind(this);
    const memberseparateValueFunc = function(rule, val, callback) {
      if (!this.ruleFormShaft.memberseparateValue) {
        return callback(new Error("请输入步长"));
      }
      callback();
    }.bind(this);
    return {
      dialogVisible: false,
      zhouqi: [],
      babyzhouqi: [],
      memberzhouqi: [],
      ruleForm: {
        new_member: "",
        loss_warning: "",
        repurchase_recommendation: ""
      },
      rules: {
        new_member: [
          {
            required: true,
            message: "请输入天数",
            trigger: "blur"
          },
          {
            pattern: /^[0-9]\d*$/,
            message: "请输入正整数",
            trigger: "blur"
          }
        ],
        loss_warning: [
          {
            required: true,
            message: "请输入天数",
            trigger: "blur"
          },
          {
            pattern: /^[0-9]\d*$/,
            message: "请输入正整数",
            trigger: "blur"
          }
        ],
        repurchase_recommendation: [
          {
            required: true,
            message: "请输入天数",
            trigger: "blur"
          },
          {
            pattern: /^[0-9]\d*$/,
            message: "请输入正整数",
            trigger: "blur"
          }
        ]
      },
      ruleFormShaft: {
        pregnantendValue: "",
        pregnantseparateValue: "",
        babyendValue: "",
        babyseparateValue: 0,
        memberendValue: 0,
        memberseparateValue: ""
      },
      rulesShaft: {
        pregnantendValue: [
          {
            required: true,
            message: "不能为空",
            trigger: "blur"
          },
          {
            pattern: /^[0-9]\d*$/,
            message: "请输入正整数",
            trigger: "blur"
          },
          {
            required: true,
            validator: pregnantendValueFunc,
            trigger: "blur"
          }
        ],
        babyendValue: [
          {
            required: true,
            message: "不能为空",
            trigger: "blur"
          },
          {
            pattern: /^[0-9]\d*$/,
            message: "请输入正整数",
            trigger: "blur"
          },
          {
            required: true,
            validator: babyseparateValueFunc,
            trigger: "blur"
          }
        ],
        memberendValue: [
          {
            required: true,
            message: "不能为空",
            trigger: "blur"
          },
          {
            pattern: /^[0-9]\d*$/,
            message: "请输入正整数",
            trigger: "blur"
          },
          {
            required: true,
            validator: memberseparateValueFunc,
            trigger: "blur"
          }
        ]
      }
    };
  },
  computed: {},
  watch: {
    "ruleFormShaft.pregnantendValue": {
      handler() {
        if (
          this.ruleFormShaft.pregnantendValue &&
          this.ruleFormShaft.pregnantseparateValue
        ) {
          this.zhouqi = [];
          let num =
            this.ruleFormShaft.pregnantendValue /
            this.ruleFormShaft.pregnantseparateValue;
          for (let i = 0; i < num; i++) {
            if (i === 0) {
              let item = `0-${this.ruleFormShaft.pregnantseparateValue *
                (i + 1)}`;
              this.zhouqi.push(item);
            } else {
              if (
                this.ruleFormShaft.pregnantseparateValue * (i + 1) >
                this.ruleFormShaft.pregnantendValue
              ) {
                let item = `${this.zhouqi[i - 1].split("-")[1]}-${
                  this.ruleFormShaft.pregnantendValue
                }`;
                this.zhouqi.push(item);
              } else {
                let item = `${this.zhouqi[i - 1].split("-")[1]}-${this
                  .ruleFormShaft.pregnantseparateValue *
                  (i + 1)}`;
                this.zhouqi.push(item);
              }
            }
          }
          this.zhouqi.forEach((v, i) => {
            this.zhouqi[i] = `${v}周`;
          });
          this.zhouqi.push(this.ruleFormShaft.pregnantendValue + "周以上");
        }
      },
      deep: true
    },
    "ruleFormShaft.pregnantseparateValue": {
      handler() {
        if (
          this.ruleFormShaft.pregnantendValue &&
          this.ruleFormShaft.pregnantseparateValue
        ) {
          this.zhouqi = [];
          let num =
            this.ruleFormShaft.pregnantendValue /
            this.ruleFormShaft.pregnantseparateValue;
          for (let i = 0; i < num; i++) {
            if (i === 0) {
              let item = `0-${this.ruleFormShaft.pregnantseparateValue *
                (i + 1)}`;
              this.zhouqi.push(item);
            } else {
              if (
                this.ruleFormShaft.pregnantseparateValue * (i + 1) >
                this.ruleFormShaft.pregnantendValue
              ) {
                let item = `${this.zhouqi[i - 1].split("-")[1]}-${
                  this.ruleFormShaft.pregnantendValue
                }`;
                this.zhouqi.push(item);
              } else {
                let item = `${this.zhouqi[i - 1].split("-")[1]}-${this
                  .ruleFormShaft.pregnantseparateValue *
                  (i + 1)}`;
                this.zhouqi.push(item);
              }
            }
          }
          this.zhouqi.forEach((v, i) => {
            this.zhouqi[i] = `${v}周`;
          });
          this.zhouqi.push(this.ruleFormShaft.pregnantendValue + "周以上");
        }
      },
      deep: true
    },
    "ruleFormShaft.babyendValue": {
      handler() {
        if (
          this.ruleFormShaft.babyendValue &&
          this.ruleFormShaft.babyseparateValue
        ) {
          this.babyzhouqi = [];
          let num =
            this.ruleFormShaft.babyendValue /
            this.ruleFormShaft.babyseparateValue;
          for (let i = 0; i < num; i++) {
            if (i === 0) {
              let item = `0-${this.ruleFormShaft.babyseparateValue * (i + 1)}`;
              this.babyzhouqi.push(item);
            } else {
              if (
                this.ruleFormShaft.babyseparateValue * (i + 1) >
                this.ruleFormShaft.babyendValue
              ) {
                let item = `${this.babyzhouqi[i - 1].split("-")[1]}-${
                  this.ruleFormShaft.babyendValue
                }`;
                this.babyzhouqi.push(item);
              } else {
                let item = `${this.babyzhouqi[i - 1].split("-")[1]}-${this
                  .ruleFormShaft.babyseparateValue *
                  (i + 1)}`;
                this.babyzhouqi.push(item);
              }
            }
          }
          this.babyzhouqi.forEach((v, i) => {
            this.babyzhouqi[i] = `${v}月`;
          });
          this.babyzhouqi.push(this.ruleFormShaft.babyendValue + "月以上");
        }
      },
      deep: true
    },
    "ruleFormShaft.babyseparateValue": {
      handler() {
        if (
          this.ruleFormShaft.babyendValue &&
          this.ruleFormShaft.babyseparateValue
        ) {
          this.babyzhouqi = [];
          let num =
            this.ruleFormShaft.babyendValue /
            this.ruleFormShaft.babyseparateValue;
          for (let i = 0; i < num; i++) {
            if (i === 0) {
              let item = `0-${this.ruleFormShaft.babyseparateValue * (i + 1)}`;
              this.babyzhouqi.push(item);
            } else {
              if (
                this.ruleFormShaft.babyseparateValue * (i + 1) >
                this.ruleFormShaft.babyendValue
              ) {
                let item = `${this.babyzhouqi[i - 1].split("-")[1]}-${
                  this.ruleFormShaft.babyendValue
                }`;
                this.babyzhouqi.push(item);
              } else {
                let item = `${this.babyzhouqi[i - 1].split("-")[1]}-${this
                  .ruleFormShaft.babyseparateValue *
                  (i + 1)}`;
                this.babyzhouqi.push(item);
              }
            }
          }
          this.babyzhouqi.forEach((v, i) => {
            this.babyzhouqi[i] = `${v}月`;
          });
          this.babyzhouqi.push(this.ruleFormShaft.babyendValue + "月以上");
        }
      },
      deep: true
    },
    "ruleFormShaft.memberendValue": {
      handler() {
        if (
          this.ruleFormShaft.memberendValue &&
          this.ruleFormShaft.memberseparateValue
        ) {
          this.memberzhouqi = [];
          let num =
            this.ruleFormShaft.memberendValue /
            this.ruleFormShaft.memberseparateValue;
          for (let i = 0; i < num; i++) {
            if (i === 0) {
              let item = `0-${this.ruleFormShaft.memberseparateValue *
                (i + 1)}`;
              this.memberzhouqi.push(item);
            } else {
              if (
                this.ruleFormShaft.memberseparateValue * (i + 1) >
                this.ruleFormShaft.memberendValue
              ) {
                let item = `${this.memberzhouqi[i - 1].split("-")[1]}-${
                  this.ruleFormShaft.memberendValue
                }`;
                this.memberzhouqi.push(item);
              } else {
                let item = `${this.memberzhouqi[i - 1].split("-")[1]}-${this
                  .ruleFormShaft.memberseparateValue *
                  (i + 1)}`;
                this.memberzhouqi.push(item);
              }
            }
          }
          this.memberzhouqi.forEach((v, i) => {
            this.memberzhouqi[i] = `${v}岁`;
          });
          this.memberzhouqi.push(this.ruleFormShaft.memberendValue + "岁以上");
        }
      },
      deep: true
    },
    "ruleFormShaft.memberseparateValue": {
      handler() {
        if (
          this.ruleFormShaft.memberendValue &&
          this.ruleFormShaft.memberseparateValue
        ) {
          this.memberzhouqi = [];
          let num =
            this.ruleFormShaft.memberendValue /
            this.ruleFormShaft.memberseparateValue;
          for (let i = 0; i < num; i++) {
            if (i === 0) {
              let item = `0-${this.ruleFormShaft.memberseparateValue *
                (i + 1)}`;
              this.memberzhouqi.push(item);
            } else {
              if (
                this.ruleFormShaft.memberseparateValue * (i + 1) >
                this.ruleFormShaft.memberendValue
              ) {
                let item = `${this.memberzhouqi[i - 1].split("-")[1]}-${
                  this.ruleFormShaft.memberendValue
                }`;
                this.memberzhouqi.push(item);
              } else {
                let item = `${this.memberzhouqi[i - 1].split("-")[1]}-${this
                  .ruleFormShaft.memberseparateValue *
                  (i + 1)}`;
                this.memberzhouqi.push(item);
              }
            }
          }
          this.memberzhouqi.forEach((v, i) => {
            this.memberzhouqi[i] = `${v}岁`;
          });
          this.memberzhouqi.push(this.ruleFormShaft.memberendValue + "岁以上");
        }
      },
      deep: true
    }
  },
  created() {},
  mounted() {
    this.querySysConfig();
  },
  methods: {
    async submitReject(formName) {
      const valid = await this.$refs[formName].validate();
      if (valid) {
        let params = this.ruleFormShaft;
        let list = [];
        for (let key in params) {
          if (key === "pregnantendValue") {
            list.push({
              endValue: params.pregnantendValue,
              separateValue: params.pregnantseparateValue,
              groupType: "pregnant",
              groupName: "孕妇生理周期"
            });
          } else if (key === "babyendValue") {
            list.push({
              endValue: params.babyendValue,
              separateValue: params.babyseparateValue,
              groupType: "baby",
              groupName: "宝宝年龄"
            });
          } else if (key === "memberendValue") {
            list.push({
              endValue: params.memberendValue,
              separateValue: params.memberseparateValue,
              groupType: "member",
              groupName: "会员年龄"
            });
          }
        }
        this.$store.dispatch("edityAgeGroupConfig", list).then(res => {
          if (res.code === "0") {
            this.$message({
              message: "操作成功",
              type: "success"
            });

            this.dialogVisible = false;
          }
        });
      } else {
        return false;
      }
    },
    async submit(formName) {
      const valid = await this.$refs[formName].validate();
      if (valid) {
        const params = JSON.parse(JSON.stringify(this.ruleForm));
        this.$store.dispatch("editMemberGroupConfig", params).then(res => {
          if (res.code === "0") {
            this.$message({
              message: "操作成功",
              type: "success"
            });
            this.querySysConfig();
          }
        });
      } else {
        return false;
      }
    },
    gogogo() {
      this.dialogVisible = true;
      this.queryAgeGroupConfig();
    },
    async queryAgeGroupConfig() {
      const { result } = await this.$store.dispatch("queryAgeGroupConfig");
      result.map(v => {
        let key = v.groupType + "separateValue";
        let k = v.groupType + "endValue";
        this.ruleFormShaft[key] = v.separateValue;
        this.ruleFormShaft[k] = v.endValue;
      });
    },
    async querySysConfig(code) {
      const { result } = await this.$store.dispatch("querySysConfig", {
        code: code
      });
      for (let key in result) {
        this.ruleForm[key] = result[key];
      }
    },
    filterGt0OrFixed0(prop) {
      this.ruleFormShaft[prop] = this.ruleFormShaft[prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleFormShaft[prop] = this.ruleFormShaft[prop].replace(
        /^(0+)|[^\d]+/g,
        ""
      );
      this.ruleFormShaft[prop] = this.ruleFormShaft[prop].replace(
        /\.{2,}/g,
        ""
      ); //两个连续的"."仅保留第一个"."
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
